export var E_FILE_TYPE;
(function (E_FILE_TYPE) {
    E_FILE_TYPE["PDF"] = "pdf";
    E_FILE_TYPE["IMAGE"] = "image";
    E_FILE_TYPE["VIDEO"] = "video";
    E_FILE_TYPE["UNKNOWN"] = "unknown";
})(E_FILE_TYPE || (E_FILE_TYPE = {}));
